import React, { useState, useEffect } from "react";

export default function HUDStat({ stat, displayType, layoutType}){

    const [boxStyle, setBoxStyle] = useState({
        backgroundColor : ""
    });
    const [nameStyle, setNameStyle] = useState({
        color: "#FFF"
    });
    const [valueStyle, setValueStyle] = useState({
        color: "#FFF"
    });

    const colorOnBlackBackground = "rgb(204,204,204)";
    const colorOnClearBackground = "#000";

    useEffect(() =>
    {
        let flexGrow = "";
        if (layoutType===1)//GRID
        {
            flexGrow= 1
        }
        let textColor = colorOnBlackBackground;
        if (stat.color.r + stat.color.g + stat.color.b >= 384)
        {
            textColor = colorOnClearBackground;
        }

        if (displayType === 1)//BORDERED// 1
        {
            setBoxStyle({
                borderBottom: "2px solid rgb(" + stat.color.r + "," + stat.color.g + "," + stat.color.b + ")",
                flexGrow
            });
            setNameStyle({
                color: "#FFF"
            });
            setValueStyle({
                color: "#FFF"
            });
        }
        else if (displayType === 2)//BACKGROUND // 2
        {
            setBoxStyle({
                backgroundColor: "rgb(" + stat.color.r + "," + stat.color.g + "," + stat.color.b + ")",
                flexGrow
            });
            setNameStyle({
                color: textColor
            });
            setValueStyle({
                color: textColor
            });
        }
        else if (displayType === 3)//VALUE // 3
        {
            setBoxStyle({
                flexGrow
            });
            setNameStyle({
                color: "#FFF"
            });
            setValueStyle({
                color: "rgb(" + stat.color.r + "," + stat.color.g + "," + stat.color.b + ")"
            });
        }
        else if (displayType === 4)//BORDER + VALUE // 4
        {
            setBoxStyle({
                borderBottom: "2px solid rgb(" + stat.color.r + "," + stat.color.g + "," + stat.color.b + ")",
                flexGrow
            });
            setNameStyle({
                color: "#FFF"
            });
            setValueStyle({
                color: "rgb(" + stat.color.r + "," + stat.color.g + "," + stat.color.b + ")"
            });
        }
        return (() =>
        {
            
        })
    }, [stat, displayType, layoutType, setBoxStyle]);

    return (
        <div className="hud-box" style={boxStyle}>
            {stat.showStatName ? <div style={nameStyle}>{stat.name}</div> : <></>}
            <div style={valueStyle}>{stat.value}</div>
        </div>
    )
}